
import React, { useContext } from 'react'
import { LocaleContext } from '../routes'
import {
  GiftDate, GiftDateLabel, GiftDateValue,
} from '../styles/gift'

export default ({ date, label }) => {
  const locale = useContext(LocaleContext)

  return (
    <GiftDate>
      <GiftDateLabel>{locale[label]}</GiftDateLabel>
      <GiftDateValue>
        {new Date(date).toLocaleDateString('fa-IR')}
      </GiftDateValue>
    </GiftDate>
  )
}